import { POST_LIST_ITEMS_ERROR, POST_LIST_ITEMS_START, POST_LIST_ITEMS_SUCCESS } from '../../types';

export default function post_list_items(state, action) {
  switch (action.type) {
    case POST_LIST_ITEMS_START:
      return { ...state };
    case POST_LIST_ITEMS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_LIST_ITEMS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}